import styled from 'styled-components';
import {
  ContainerSection,
  HeaderSection
} from '@/main/components/shared/styles';

export const HeaderWarehouse = styled(HeaderSection)``;

interface IAreaForm {
  gridTemplateColumns?: string;
}

export const Container = styled(ContainerSection)`
 @media (max-width: 426px) {

    button {
      width: 100%;
      max-width: 100%;
      padding: .4rem 0 !important;
      margin: 0;
    }
  }
`;

export const AreaForm = styled.div<IAreaForm>`
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns || '1fr 1fr 1fr'};
  gap: 1rem;
  margin: 0 0 50px 0;

  @media (max-width: 1130px) {
    grid-template-columns: 1fr 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: .4rem 0 !important;
      margin: 0;
    }
  }

  @media (max-width: 795px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: .4rem 0 !important;
      margin: 0;
    }
  }
`;

export const AreaError = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > p {
    margin: 0 0 0 .4rem;
  }
`;

export const AreaInputNumber = styled.div`
  position: relative;
  &&&{
    .MuiAutocomplete-inputRoot{
      background: ${({ theme }) => theme.grayLight};
      margin: 14px 44px 0px 0px;
      padding: 0;
      border-radius: 2px;
    }
    svg{
      background: none !important;
    }
  }
`;

export const AreaCheckbox = styled.div`
  position: absolute;
  top: 14px;
  right: .6rem;
  margin: 0;

  .MuiFormControlLabel-root{
    margin:0;
  }

  .MuiCheckbox-root{
    padding: 0;
  }

  .MuiCheckbox-colorSecondary.Mui-checked{
    color: #fab01c;
  }
`;

interface ICustomColumn {
  $width?: string;
}
export const CustomColumn = styled.div<ICustomColumn>`
  width: 50%;
  max-width: ${({ $width }) => $width || '100%'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: '0 0 5px 0';
`;

export const CollumnPhoneNumber = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  word-break: keep-all;
  white-space: nowrap;
`;


